import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  data: null,
  error: null,
};

const GetBundleProductRelationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_BUNDLE_PRODUCT_RELATION_SUCCESS:
      return {
        ...state,
        data: action.response,
        error: null,
      };
    case actionTypes.GET_BUNDLE_PRODUCT_RELATION_ERROR:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default GetBundleProductRelationReducer;
